import { render, staticRenderFns } from "./ClienteVenta.vue?vue&type=template&id=2b391a26&scoped=true"
import script from "./ClienteVenta.vue?vue&type=script&lang=js"
export * from "./ClienteVenta.vue?vue&type=script&lang=js"
import style0 from "./ClienteVenta.vue?vue&type=style&index=0&id=2b391a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b391a26",
  null
  
)

export default component.exports